import {
    AccordionComponent,
    Button,
    GenericError,
    ModalComponent,
    ModalHeader,
    ToastMessage,
} from "components";
import React from "react";
import Spinner from "components/Spinner";
import { ButtonRow, SeparateLine } from "styles/elements/main";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import useVerificationSubmit from "hooks/useVerificationSubmit";
import useVerificationObjection from "hooks/useVerificationObjection";
import PersonalInfo from "./personalInfo";
import WorkingInfo from "./workingInfo";
import CompanyInfo from "./companyInfo";
import PaymentInfo from "./paymentInfo";
import useFetchSupplierData from "../config/useFetchSupplierData";

const VerifySupplierModal = ({ open, onClose, supplierId, supplierStatus }) => {
    const { selectedSupplierData, supplierAttachments } = useFetchSupplierData(
        supplierId,
        "paymentMethod,attachments"
    );
    const { objections, handleObjections } = useVerificationObjection();

    const { onSuccess, isLoading, handleReviewSubmition, backEndErorr } = useVerificationSubmit(
        objections,
        onClose,
        supplierId,
        "suppliers"
    );
    return (
        <>
            <ModalComponent
                open={open}
                onClose={onClose}
                header={
                    <ModalHeader
                        entityId={supplierId}
                        entityName="Supplier Profile Details"
                        entityStatus={supplierStatus}
                    />
                }
                borderedHeader
                size="large"
            >
                <AccordionComponent
                    title="Personal Info"
                    defaultExpanded
                    body={
                        <PersonalInfo
                            newSupplierData={selectedSupplierData}
                            supplierAttachments={supplierAttachments}
                            selectedSupplierId={supplierId}
                            handleObjections={handleObjections}
                            isQARole
                        />
                    }
                />
                <SeparateLine />
                <AccordionComponent
                    title="Working Info"
                    defaultExpanded
                    body={
                        <WorkingInfo
                            newSupplierData={selectedSupplierData}
                            supplierAttachments={supplierAttachments}
                            handleObjections={handleObjections}
                            isQARole
                        />
                    }
                />
                <SeparateLine />
                <AccordionComponent
                    title="Company Info"
                    defaultExpanded
                    body={
                        <CompanyInfo
                            newSupplierData={selectedSupplierData}
                            supplierAttachments={supplierAttachments}
                            selectedSupplierId={supplierId}
                            handleObjections={handleObjections}
                            isQARole
                        />
                    }
                />
                <SeparateLine />
                <AccordionComponent
                    title="Payment Info"
                    defaultExpanded
                    body={
                        <PaymentInfo
                            newSupplierData={selectedSupplierData}
                            supplierAttachments={supplierAttachments}
                            handleObjections={handleObjections}
                            isQARole
                        />
                    }
                />
                {backEndErorr && <GenericError errorMassege={backEndErorr} />}
                <ButtonRow>
                    <Button
                        type="button"
                        onChange={onClose}
                        name="Cancel"
                        btnStyle="secondBtn"
                    />
                    <Button
                        t
                        btnStyle={isLoading || !(objections.length > 0) ? "disabled" : "primaryBtn"}
                        type="submit"
                        name={isLoading ? <Spinner /> : "Submit"}
                        disabled={!(objections.length > 0)}
                        icon={!isLoading && <AddCircleOutlineOutlinedIcon />}
                        onChange={handleReviewSubmition}
                    />
                </ButtonRow>
            </ModalComponent>
            {onSuccess && (
                <ToastMessage
                    name="supplier"
                    type="success"
                    text="verification success"
                    showToast={onSuccess}
                />
            )}
        </>
    );
};

export default VerifySupplierModal;
